import React, {useState} from 'react';

const GlobalDataContext = React.createContext({});

// @ts-ignore
const GlobalDataContextProvider = ({ children }) => {
    const [europeRecords, setEuropeRecords] = useState<{}>({});
    const [latamRecords, setLatamRecords] = useState<{}>({});
    const [latamHerfindahlRecords, setLatamHerfindahlRecords] = useState<{}>({});
    const [latamConcentrationRecords, setLatamConcentrationRecords] = useState<boolean>(false);
    const [allDataLoaded, setAllDataLoaded] = useState<boolean>(false);

    const setData = (europeRecords: any,
                     latamRecords: any,
                     latamHerfindahlRecords: any,
                     latamConcentrationRecords: any) => {
        setEuropeRecords(europeRecords);
        setLatamRecords(latamRecords);
        setLatamHerfindahlRecords(latamHerfindahlRecords);
        setLatamConcentrationRecords(latamConcentrationRecords);

        if (Object.keys(europeRecords).length
              && Object.keys(latamRecords).length
              && Object.keys(latamHerfindahlRecords).length
              && Object.keys(latamConcentrationRecords).length) {
            setAllDataLoaded(true);
        }
    };

    return (
        <GlobalDataContext.Provider
            value={{
              europeRecords,
              latamRecords,
              latamHerfindahlRecords,
              latamConcentrationRecords,
              setData,
              allDataLoaded
            }} >
          {children}
        </GlobalDataContext.Provider>
    );
};

export {
    GlobalDataContextProvider,
    GlobalDataContext,
}
